<script>
import { Bar, Line, mixins } from 'vue-chartjs';
const { reactiveProp } = mixins;

export default {
    mixins: [Line, Bar, reactiveProp],
    props: {
        streamData: {
            type: Object,
            default: () => {},
            required: false
        },
        barData: {
            type: Array,
            default: () => [],
            required: false
        }
    },
    data() {
        return {
            options: {
                responsive: true,
                animation: false,
                legend: {
                    position: "bottom"
                },
                scales: {
                    xAxes: [{
                        scaleLabel: {
                            display: true,
                            labelString: '時間(24h)',
                            offset: true
                        }
                    }],
                    yAxes: [{
                        ticks: {
                            beginAtZero: true,
                            stepSize: 10,
                            max: 30
                        },
                        scaleLabel: {
                            display: true,
                            labelString: '最大人数(人)'
                        }
                    }]
                }
            }
        }
    },
    mounted() {
        this.createThresholdNumber()
        // グラフ生成
        this.renderChart(this.chartData, this.options)
    },
    methods: {
        createThresholdNumber() {
            // グラフのy軸の最大値を10の位で切り上げ
            const digit = 10
            let num = Math.floor(this.streamData.threshold * 1.5)
            let ceilNumber = Math.ceil(num / digit) * digit;
            this.barData.forEach(barNum => {
                if (barNum > ceilNumber) {
                    ceilNumber = Math.ceil(barNum / digit) * digit;
                }
            })
            this.options.scales.yAxes[0].ticks.max = ceilNumber
        }
    },
    watch: {
        chartData(val) {
            this._data._chart.destroy()
            this.createThresholdNumber()
            this.renderChart(val, this.options)
        }
    }
}

</script>